var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_vm._v("Sorry, looks like you have no access. If you feel this is in error, please contact us.")])}
var staticRenderFns = []

export { render, staticRenderFns }